









import { defineComponent } from '@vue/composition-api';
import { ObserveVisibility } from 'vue-observe-visibility';

export default defineComponent({
  name: 'EditorNodeWrapper',
  directives: {
    'observe-visibility': ObserveVisibility,
  },
});
